export const isAuthenticated = (state) => {
	const tokenDetailsString = sessionStorage.getItem('token');
	if (tokenDetailsString) return true;
	return false;
};
